import { render, staticRenderFns } from "./profile-photos.vue?vue&type=template&id=cc8acbce&scoped=true&"
import script from "./profile-photos.vue?vue&type=script&lang=js&"
export * from "./profile-photos.vue?vue&type=script&lang=js&"
import style0 from "./profile-photos.vue?vue&type=style&index=0&id=cc8acbce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8acbce",
  null
  
)

export default component.exports